module.exports = __webpack_public_path__ + "static/media/halo-clean-banner-mobile.e65f4159.svg";